export default __webpack_public_path__ + "static/media/5.0d34fab8.svg";